import type { DirectiveBinding } from 'vue'

const vVisible = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden'
    el.style.opacity = binding.value ? '1' : '0'
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden'
    el.style.opacity = binding.value ? '1' : '0'
  }
}

export default vVisible
